export default "__VITE_ASSET__C3Pc2Hex__"